module.exports = __webpack_public_path__ + "img/screenshot-XD-perspective.d13365dc.png";